import React, { Component, PropTypes } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 100,
    boxSizing: 'border-box',
    '&selected': {
      border: `solid 1px ${Colors.brightOrange}`,
      left: {
        boxSizing: 'border-box',
        position: 'absolute',
        borderStyle: 'none dashed none none',
        borderWidth: 1,
        width: 1,
        borderColor: Colors.brightOrange,
        left: 0,
        top: -10000,
        bottom: -10000,
        marginLeft: -1
      },
      right: {
        boxSizing: 'border-box',
        position: 'absolute',
        borderStyle: 'none none none dashed',
        borderWidth: 1,
        width: 1,
        borderColor: Colors.brightOrange,
        right: 0,
        top: -10000,
        bottom: -10000,
        marginRight: -1
      },
      top: {
        boxSizing: 'border-box',
        position: 'absolute',
        borderStyle: 'dashed none none none',
        borderWidth: 1,
        height: 1,
        borderColor: Colors.brightOrange,
        top: 0,
        left: -10000,
        right: -10000,
        marginTop: -1
      },
      bottom: {
        boxSizing: 'border-box',
        position: 'absolute',
        borderStyle: 'none none dashed none',
        borderWidth: 1,
        height: 1,
        borderColor: Colors.brightOrange,
        bottom: 0,
        left: -10000,
        right: -10000,
        marginBottom: -1
      },
      cornerTopLeft: {
        boxSizing: 'border-box',
        position: 'absolute',
        left: `${-Units.base / 2}px`,
        top: `${-Units.base / 2}px`,
        borderRadius: `${Units.base / 2}px`,
        backgroundColor: Colors.fullWhite,
        borderWidth: 1,
        borderColor: Colors.brightOrange,
        borderStyle: 'solid',
        width: Units.base,
        height: Units.base
      },
      cornerTopRight: {
        boxSizing: 'border-box',
        position: 'absolute',
        right: `${-Units.base / 2}px`,
        top: `${-Units.base / 2}px`,
        borderRadius: `${Units.base / 2}px`,
        backgroundColor: Colors.fullWhite,
        borderWidth: 1,
        borderColor: Colors.brightOrange,
        borderStyle: 'solid',
        width: Units.base,
        height: Units.base
      },
      cornerBottomLeft: {
        boxSizing: 'border-box',
        position: 'absolute',
        left: `${-Units.base / 2}px`,
        bottom: `${-Units.base / 2}px`,
        borderRadius: `${Units.base / 2}px`,
        backgroundColor: Colors.fullWhite,
        borderWidth: 1,
        borderColor: Colors.brightOrange,
        borderStyle: 'solid',
        width: Units.base,
        height: Units.base
      },
      cornerBottomRight: {
        boxSizing: 'border-box',
        position: 'absolute',
        right: `${-Units.base / 2}px`,
        bottom: `${-Units.base / 2}px`,
        borderRadius: `${Units.base / 2}px`,
        backgroundColor: Colors.fullWhite,
        borderWidth: 1,
        borderColor: Colors.brightOrange,
        borderStyle: 'solid',
        width: Units.base,
        height: Units.base
      }
    }
  }
});

class SelectedMarker extends Component {
  static propTypes = {
    selected: PropTypes.bool
  };

  render() {
    const { selected } = this.props;
    return (
      <div className={classNames(css.root, { [css.selected]: selected })}>
        <div className={css.left} />
        <div className={css.right} />
        <div className={css.top} />
        <div className={css.bottom} />
        <div className={css.cornerTopLeft} />
        <div className={css.cornerTopRight} />
        <div className={css.cornerBottomLeft} />
        <div className={css.cornerBottomRight} />
      </div>
    );
  }
}

export default SelectedMarker;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/SelectedMarker.js